"use client";
import { useMemo } from "react";
const DOTS = "...";
const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => i + start);
};
export function usePagination({ count, skip, total }) {
    const currentPage = skip / count;
    const paginationRange = useMemo(() => {
        const totalPageCount = Math.ceil(total / count) - 1;
        const totalPageNumbers = 6;
        if (totalPageNumbers >= totalPageCount) {
            return range(0, totalPageCount);
        }
        const leftSiblingIndex = Math.max(currentPage - 1, 1);
        const rightSiblingIndex = Math.min(currentPage + 1, totalPageCount);
        const showLeftDots = leftSiblingIndex > 2;
        const showRightDots = rightSiblingIndex < totalPageCount - 2;
        const firstPageIndex = 0;
        const lastPageIndex = totalPageCount;
        if (!showLeftDots && showRightDots) {
            const leftItemCount = 2 + totalPageNumbers / 2;
            const leftRange = range(0, leftItemCount);
            return [...leftRange, DOTS, totalPageCount];
        }
        if (showLeftDots && !showRightDots) {
            const rightItemCount = 2 + totalPageNumbers / 2;
            const rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
            return [firstPageIndex, DOTS, ...rightRange];
        }
        if (showLeftDots && showRightDots) {
            const middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
        }
    }, [count, currentPage, total]);
    return paginationRange;
}
export default usePagination;
//# sourceMappingURL=use-pagination.js.map